import { RestaurantConfig, RestaurantPage } from 'src/apollo/sites'

import { SiteData } from 'shared/js/types'

type Props = {
  config?: RestaurantConfig
  sitePages?: RestaurantPage[] | null
}

export const getLinkEnums = ({ config, sitePages }: Props) => {
  return [
    { displayName: 'Homepage', value: '/' },
    { displayName: 'Menu', value: '/menu' },
    ...(config?.isOnlineOrderingEnabled
      ? [{ displayName: 'Online Ordering', value: '/order' }]
      : []),
    ...(sitePages?.map((p) => ({ displayName: p.route, value: p.route })) || [])
  ]
}

const NORMALIZE_URI_PATH_REPLACE_RE = /^([\s/]+)|([\s/]+)$/g

export const normalizeUriPath = (path: string) =>
  path.replace(NORMALIZE_URI_PATH_REPLACE_RE, '') || '/'

export const normalizeUriPathWithLeadingSlash = (
  path: string
): `/${string}` => {
  const normalizedPath = normalizeUriPath(path)
  return normalizedPath === '/' ? '/' : `/${normalizedPath}`
}

export const getLinkEnumsFromSiteData = (
  restaurant: SiteData,
  includeHomepage: boolean = false
) => {
  const hasOnlineOrdering =
    !restaurant.config?.ooConfig?.optedOut &&
    !!restaurant.config?.isOnlineOrderingEnabled

  return [
    ...(includeHomepage ? [{ displayName: 'Homepage', value: '/' }] : []),
    ...(!restaurant.config?.menuConfig?.optedOut
      ? [{ displayName: 'Menu', value: '/menu' }]
      : []),
    ...(hasOnlineOrdering
      ? [{ displayName: 'Online Ordering', value: '/order' }]
      : []),
    ...(restaurant?.additionalPages ?? [])
      .filter((p: any) => p && !p.deleted)
      .map((page: any) => ({
        displayName: page?.meta?.title || normalizeUriPath(page.route),
        value: normalizeUriPathWithLeadingSlash(page.route)
      }))
  ]
}
